<template>
	<div class="index">
		<div style="width: 1200px; margin: 0 auto;">
			<div class="top_title">
            <!-- 左侧位置 -->
            <div class="top_title_left">
                 <div class="left_icon">
                    <img src="../../assets/xiangning/news_detail/location.png" alt="">
                </div>
                <div class="left_text">
                    当前位置：党的二十大>详情
                </div>
            </div>
            <div class="right_back">
                <div class="right_back_icon"><img src="../../assets/xiangning/news_detail/back.png" alt=""></div>
                <div @click="$router.go(-1)">返回</div>
            </div>
           </div>
           <!-- 文章内容 -->
           <div class="artical_content">
            <!-- 上方文章标题 -->
               <div class="artical_content_title">
                   <div class="artical_content_title_main">
                    {{ title }}
                   </div>
                   <!-- 发布时间及来源 -->
                   <div class="artical_content_title_time">
                      <!-- <span>2022-08-09</span><span>来源：人民网</span> -->
                   </div>
                   <!-- 调整字号大小 -->
                   <!-- <div class="changeFontSize" >
                      <span>字号调节：</span>
                  
                      <div @click="changeFontSize('add')" class="changeFontSize_A"><img src="../../assets/xiangning/news_detail/fontAdd.png" alt=""></div>
                 
                      <div @click="changeFontSize('red')" class="changeFontSize_A"><img src="../../assets/xiangning/news_detail/fontR.png" alt=""></div>
                   </div> -->
               </div>
               <div class="rsd_video_play">
                    <div class="rsd_video_play_left_video">
                        <video @contextmenu.prevent width="100%" height="100%" controlslist="nodownload" id="my-video" style="background-color: #000000;" class="left" controls preload autoplay="autoplay" :src="kc_VideoSrc">
                            <source  type='video/mp4'>
                        </video>

                    </div>
                    <div class="rsd_video_play_right_list">
                       <div class="rsd_video_play_right_list_top">
                          <div @click="seltecContent=1" :style="{color:seltecContent==1?'#fff':'',borderBottom: seltecContent==1?'1px solid #C51212':''}" class="rsd_video_play_right_list_top_item">课程简介</div>
                          <div @click="seltecContent=2"   :style="{color:seltecContent==2?'#fff':'',borderBottom: seltecContent==2?'1px solid #C51212':''}"  class="rsd_video_play_right_list_top_item">课程目录</div>
                       </div>
                       <div v-if="seltecContent==2" class="rsd_video_play_right_title_box">
                            <!-- 标题列表 -->
                             <div v-if="bs_id==3"  @click="changeTitle(item)" :style="{ backgroundColor:selectTitleId==item.id?'#1E1E1E':''}" class="rsd_video_play_right_title" v-for="item in resouce">
                                    <div :style="{ color:selectTitleId==item.id?'#FFE74A':''}" class="rsd_video_play_right_title_item" >
                                        {{item.video_title}}
                                    </div>
                             </div>
                             <div v-if="bs_id==1"   :style="{ backgroundColor:true?'#1E1E1E':''}" class="rsd_video_play_right_title" >
                                    <div :style="{ color:true?'#FFE74A':''}" class="rsd_video_play_right_title_item" >
                                       {{ title }}
                                    </div>
                             </div>
                       </div>
                       <!-- 课程介绍 -->
                       <div v-if="seltecContent==1" class="rsd_video_play_right_content">
                       {{ kc_content }}
                       </div>
                       <div class="rsd_video_play_right_content_bottom">
                             <!-- <div   class="rsd_video_play_right_content_bottom_item">
                                        <span>
                                            <img v-if="false" src="../../assets/xiangning/icon/shoucang.png" alt="">
                                            <img v-if="true" src="../../assets/xiangning/icon/shoucang-yishoucang.png" alt="">
                                        </span>
                                        资源收藏
                             </div> -->
                             <!-- <div   class="rsd_video_play_right_content_bottom_item">
                                       <span>
                                            <img src="../../assets/xiangning/icon/sancode.png" alt="">
                                        </span>
                                        扫码带走
                            </div> -->
                            <!-- <div   class="rsd_video_play_right_content_bottom_item">
                                    <span>
                                        <img src="../../assets/xiangning/icon/download.png" alt="">
                                    </span>
                                    资源下载
                            </div> -->
                       </div>
                    </div>
               </div>
           </div>
           <!-- 相关推荐 -->
           <div class="rsd_bottom_title">
               <div class="rsd_bottom_title_content">
                    <div class="rsd_bottom_title_content_left">
                        相关推荐
                    </div>
                    <div class="rsd_bottom_title_content_left_right">
                        <!-- <span>
                            <img src="../../assets/xiangning/news_detail/change.png" alt="">
                        </span>
                        换一批 -->
                    </div>
               </div>
           </div>
            <div class="rsd_bottom_content">
                <div @click="goRsdDetail(item,1)" class="rsd_bottom_content_item" v-for="item in xgtjList" >
                     <div class="rsd_bottom_content_item_top">
                             <img :src="item.sz_img" alt="">
                     </div>
                     <div class="rsd_bottom_content_item_bottom">
                         {{ item.title }}
                     </div>
                </div>
            </div>
		</div>
			
	</div>
</template>
<script>
    import {rsd} from '@/axios'
import { RETURN } from 'core-js/modules/_for-of'
	export default{
		data(){
			return{
                bs_id:'',
                title:'',
                kc_content:'',
                kc_VideoSrc:'',
                resouce:[],
				index:0,
				// 字体大小,
				sizes:14,
                seltecContent:1,
                selectTitleId:1,
                xgtjList:[]
               
			}
		},
		// components:{ Title },
		methods:{
            
            changeTitle(data){
                this.selectTitleId=data.id
                this.kc_content=data.content
                this.kc_VideoSrc=data.video_url
            },
			handleScroll(){
                        let that=this
                        // 判断页面的滚动距离如果大于500展示回到顶部按钮
                        if (window.pageYOffset>500) {
                            that.isShow=true
                        }else{
                            that.isShow=false
                        }
                    },
            toTopHandle(){
                window.scrollTo({ 
                    top: 0, 
                    behavior: "smooth" 
                });
            },
            // 改变页面字体大小
            changeFontSize(val){
                let that=this
            if (val=='add') {
                // 加大字号
                that.sizes=that.sizes+2
            }else{
                that.sizes=that.sizes-2
            }
        
            },
            // 获取资源详情
            getResouceDetail(){
                 let that=this
                 rsd.sxylDetail({id:that.$route.query.id,flag:that.$route.query.flag}).then((res)=>{
                    if (res.code==200) {
                        that.bs_id=res.data.bs_id
                       if (res.data.bs_id==3) {
                        that.title=res.data.title
                        that.resouce=res.data.resouce
                        that.kc_VideoSrc=res.data.resouce[0].video_url
                        that.kc_content=res.data.resouce[0].content
                        that.selectTitleId=res.data.resouce[0].id
                        that.xgtjList=res.xl
                       }else if (res.data.bs_id==1) {
                           that.title=res.data.title
                           that.kc_VideoSrc=res.data.ment_url
                           that.kc_content=res.data.content
                           that.xgtjList=res.xl
                       }
                    }
                 })
            },
            // 点击相关推荐跳转至详情页面
            goRsdDetail(item,flag){
                if (item.bs_id==8) {
                    this.$router.push({
					path:'/pdf_play',
					query:{
						id:item.id,
						flag:flag,
						
					}
				})
                }
                
            }
			
		  },
		mounted(){
			  // 给页面添加滑动时间
			  window.addEventListener("scroll", this.handleScroll);
              this.getResouceDetail()
	
		},
		computed: {
                    // 计算属性，返回当前是否应该显示返回顶部按钮
                    shouldShowBackToTop() {
                    return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
                    }
                },
		created() {
		
		}
	}
</script>

<style  scoped>
	.top_title{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.top_title_left{
    display: flex;
    align-items: center;
}
.left_icon{
    width: 20px;
    height: 20px;
    margin-right: 5px;
}
img{
    width: 100%;
    height: 100%;
}
.left_text{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    height: 20px;
    line-height: 20px;
    background-color: #fff;
}
.right_back{
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 10px;
}
.right_back:hover{
    font-weight: 800;
    color: #C9010A;
}
.right_back_icon{
    height: 10px;
    width: 12px;
    margin-right: 5px;
}
.right_back_icon img{
    height: 100%;
    width: 100%;
}
.artical_content{
    /* border-bottom: 1px solid #D8D8D8; */
}
.artical_content_title{
    margin-top: 30px;
    padding: 0 140px;
    position: relative;
}
.artical_content_title_main{
    width: 100%;
    white-space: wrap;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
    margin-bottom: 10px;
}
.artical_content_title_time{
    font-family: PingFangSC-Regular;
    text-align: center;
}
.artical_content_title_time span{
     margin-right: 10px;
     font-size: 14px;
     font-weight: normal;
     text-align: center;
     letter-spacing: 0em;
 
     color: #000000;
} 
.backTop{
    width: 70px;
    height: 70px;
    position: fixed;
    top: 500px;
    right: 224px;
}
.backTop img{
    width: 70px;
    height: 70px;
}
.changeFontSize{
    z-index: 99;
    position: absolute;
    top:3PX;
    right: 0;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #1C76FD;
    display: flex;
    align-items: center;
}
.changeFontSize_A{
    display: inline-block;
    width: 17px;
    height: 28px;
    margin-left: 10px;
}
.rsd_video_play{
    width: 100%;
    height: 535px;
    margin-top: 20px;
    display: flex;
    /* background-color: pink; */
}
.rsd_video_play_left_video{
    height: 100%;
    width: 880px;
    background-color: #555555;
}
.rsd_video_play_right_list{
    width: 320px;
    height: 535px;
    background-color: #2D2D2D;

}
.rsd_video_play_right_list_top{
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #1E1E1E;
    display: flex;
    justify-content:center;
    box-sizing: border-box;

}
.rsd_video_play_right_list_top_item{
    cursor: pointer;
    line-height: 50px;
    height: 100%;
    width: 60px;
    box-sizing: border-box;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    /* width: 160px; */

}
.rsd_video_play_right_list_top_item:nth-child(1){
    margin-right: 42px;
   
}
.rsd_video_play_right_title_box{
    width: 100%;
    height: 400px;
    overflow-y: auto;
}
.rsd_video_play_right_title{
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    padding: 20px 30px;
}
.rsd_video_play_right_title:hover{
    background-color: #1E1E1E;
    
}
.rsd_video_play_right_title:hover .rsd_video_play_right_title_item{
    color: #FFE74A;
}
.rsd_video_play_right_title_item{
    width: 100%;
    height: 100%;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    line-height: 20px;
    color: #FFF;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 将对象作为弹性伸缩盒子模型显示 */
    display: -webkit-box;
    /* 限制在一个块元素显示的文本的行数 */
    /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
    -webkit-line-clamp: 2;
    /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-box-orient: vertical;
}
.rsd_video_play_right_content{
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 25px;
    font-weight: normal;
    text-align: justify; /* 浏览器可能不支持 */
    letter-spacing: 0em;
    color: #999999;
    text-indent: 28px;
    box-sizing: border-box;
    padding:10px 15px ;
    height: 400px;
    overflow: auto;
 
}
.rsd_video_play_right_content_bottom{
    width: 100%;
    height: 80px;
    /* background-color: skyblue; */
    box-sizing: border-box;
    padding: 0px 16px;
    display: flex;
   justify-content: space-between;
}
.rsd_video_play_right_content_bottom_item{
    margin-top: 20px;
    width: 88px;
    height: 32px;
    background-color: #1E1E1E;
    border-radius: 4px;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    display: flex;
    align-items: center;
}
.rsd_video_play_right_content_bottom_item span{
    /* display: inline-block; */
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
    line-height: 16px;
    margin-bottom: 2px;
    
}
.rsd_video_play_right_content_bottom_item span img{
    width: 100%;
    height: 100%;
}
.rsd_bottom_title{
    width: 100%;
    height: 40px;
    background-color: #F7F7F7;
    box-sizing: border-box;
    padding: 9px 6px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.rsd_bottom_title_content{
    box-sizing: border-box;
    height: 22px;
    border-left: 4px solid #EE632B;
    display: flex;
    justify-content: space-between;

}
.rsd_bottom_title_content_left{
    height: 100%;
    padding-left: 10px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: 0.1em;
    color: #000000;
    line-height: 22px;
}
.rsd_bottom_title_content_left_right{
    height: 22px;
    line-height: 22px;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
}
.rsd_bottom_title_content_left_right span{
    display: inline-block;
    width: 15px;
    height: 12px;
}
.rsd_bottom_title_content_left_right span img{
    width: 100%;
    height: 100%;
}
.rsd_bottom_title_content_left_right:hover{
    color: #EE632B;
    cursor: pointer;
}
.rsd_bottom_content{
    width: 100%;
    display: flex;
    margin-bottom: 40px;
    flex-wrap: wrap;
}
.rsd_bottom_content_item{
    border-radius: 4px;
    overflow: hidden;
    width: 222px;
    height: 166px;
    border: 1px solid #ECEEF4;
    margin-right: 20px;
    margin-bottom: 20px;
    /* background-color: pink; */
}
.rsd_bottom_content_item:nth-child(5n){
    margin-right: 0;
}
.rsd_bottom_content_item_top{
    width: 100%;
    height: 126px;
    /* background-color: skyblue; */
}
.rsd_bottom_content_item_top img{
    width: 100%;
    height: 100%;
}
.rsd_bottom_content_item_bottom{
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0em;
    color: #000000;
}
</style>
